/* Maison Dolce - pastilles couleur a la place des boutons texte */
(function () {
  "use strict";
  var COLOR_WORDS = ["couleur", "coloris", "color", "motif", "mod", "design", "style"];
  function isColorLabel(txt) {
    var s = String(txt || "").trim().toLowerCase();
    for (var i = 0; i < COLOR_WORDS.length; i++) { if (s.indexOf(COLOR_WORDS[i]) === 0) return true; }
    return false;
  }
  function run() {
    var node = document.getElementById("variantData");
    var thumbs = document.querySelectorAll("#ppThumbs .pp-thumb img");
    if (!node || !thumbs.length) return;
    var variants;
    try { variants = JSON.parse(node.textContent); } catch (e) { return; }
    if (!variants || !variants.length) return;

    var groups = document.querySelectorAll("[data-opt-group]");
    for (var g = 0; g < groups.length; g++) {
      var group = groups[g];
      var idx = parseInt(group.getAttribute("data-opt-group"), 10);
      var wrap = group.closest ? group.closest(".variant-group") : null;
      var labelEl = wrap ? wrap.querySelector(".variant-label") : null;
      if (!labelEl || !isColorLabel(labelEl.childNodes[0] ? labelEl.childNodes[0].textContent : "")) continue;

      var btns = group.querySelectorAll(".swatch");
      if (btns.length < 3) continue;

      var map = {};
      for (var v = 0; v < variants.length; v++) {
        var val = variants[v].options && variants[v].options[idx];
        var fi = variants[v].featured_index;
        if (!val || map[val]) continue;
        if (fi === null || fi === undefined) continue;
        if (!thumbs[fi]) continue;
        map[val] = thumbs[fi].getAttribute("src");
      }

      var ok = true;
      for (var b = 0; b < btns.length; b++) {
        if (!map[btns[b].getAttribute("data-val")]) { ok = false; break; }
      }
      if (!ok) continue;

      group.classList.add("swatches--img");
      for (var k = 0; k < btns.length; k++) {
        var btn = btns[k];
        var value = btn.getAttribute("data-val");
        btn.classList.add("swatch--img");
        btn.setAttribute("title", value);
        btn.setAttribute("aria-label", value);
        btn.innerHTML =
          '<img src="' + map[value] + '" alt="" width="44" height="44" loading="lazy" decoding="async">' +
          '<span class="swatch__sr"></span>';
        btn.querySelector(".swatch__sr").textContent = value;
      }
    }
  }
  if (document.readyState !== "loading") run();
  else document.addEventListener("DOMContentLoaded", run);
})();
